import { Box, CircularProgress, Typography } from '@mui/material'

interface LoadingProps {
  message?: string
}

const Loading = ({ message = 'Loading...' }: LoadingProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 200,
        py: 6,
        px: 3
      }}
    >
      <CircularProgress
        size={36}
        thickness={4}
        sx={{ color: 'primary.main' }}
      />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        {message}
      </Typography>
    </Box>
  )
}

export default Loading
